import { h, render } from 'preact'
import SearchApp from './containers/App/index'

const Search = () => {
  let $$components

  const self = {
    init () {
      $$components = [...document.querySelectorAll('.Search')]
      if ($$components.length < 1) return

      $$components.forEach($component => render(<SearchApp />, $component))
    }
  }

  return self
}

export default Search
